import React, {useContext} from 'react';
import {Pagination as DesyPagination} from '@bonprix/design-system';
import {loadOn} from '../LoaderSlice.jsx';
import {useDispatch} from 'react-redux';
import {getContentAjaxUrl, yieldToMain} from '../ArticleOverviewHelper';
import Landmark from '@core/scripts/components/landmark-adapter';
import {Constants} from '../view-constants';
import {setContentAjaxCall} from '../AjaxCallSlice.jsx';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';

export default function Pagination({pagination, isShopContent}) {
    const dispatch = useDispatch();
    const {contentAjaxUrl, currentSearchParams, prettyUrl} = useContext(articleOverviewStaticContext);

    const handleOnClick = (newPage, origin) => {
        yieldToMain(() => dispatch(loadOn()));
        yieldToMain(() => {
            const lmPageValue = origin === 'page' ? newPage : origin;
            const lmData = `${isShopContent ? Constants.LANDMARK_PAGETYPE_AOP : Constants.LANDMARK_PAGETYPE_SRP}_page_${lmPageValue}`;
            Landmark.sendClickLandmark(lmData);

            const currentSearchParamsCopy = new URLSearchParams(currentSearchParams.current);
            currentSearchParamsCopy.delete(Constants.SEARCH_PARAMS_ANCHOR);
            currentSearchParamsCopy.set(Constants.SEARCH_PARAMS_PAGE, newPage);
            currentSearchParams.current = currentSearchParamsCopy;

            const formattedParams = `?${currentSearchParamsCopy.toString()}`;
            const contentAjaxCall = getContentAjaxUrl(prettyUrl.current, formattedParams, contentAjaxUrl);

            dispatch(setContentAjaxCall([contentAjaxCall, false]));
        });
    };

    return (
        <div className="pagination__wrapper">
            <DesyPagination
                currentPage={pagination.currentPageNumber}
                totalPages={pagination.numberOfPages}
                onPageChange={handleOnClick}
                baseHref={pagination.baseHref}
            />
        </div>
    );
}
